import { useSyncExternalStore } from 'react';

import {
  type DismissedPhases,
  readDismissedPhases,
  subscribeDismissedPhases,
} from '@/viewmodel/features/quota/state/trialBannerDismissal';

export function useDismissedTrialPhases(): DismissedPhases {
  return useSyncExternalStore(subscribeDismissedPhases, readDismissedPhases, readDismissedPhases);
}
